import React, { Suspense, useState } from 'react';
import { Avatar, Difficulty, StyledFlex, theme } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrosshairs, faFlag, faRoute, faListCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faFire } from '@fortawesome/free-solid-svg-icons';
import { StyledLoading } from 'src/common/components';
import { useGetUserQuery } from 'src/common/slices';
import { useGetScoreboardDataQuery } from 'src/features/room/room.slice';
import { FireshipCampaignBar } from 'src/features/campaigns/components/fireship-bar';
import { StyledContentWrapper, StyledTitle } from '../../congratulations-full-screen.styles';
import { RecordsStepProps } from '../../congratulations-full-screen.types';
import { StyledSentFeedbackMsg } from '../../../completion-modal/completion-modal.styles';
import { StyledAvatar, StyledCircleCheck, StyledRedeemTicketsWrapper } from './records-step.styles';
import { RecordItem } from './record-item';
export const RecordsStep = ({
  currentRoom,
  isLoading,
  isFeedbackSent
}: RecordsStepProps) => {
  const [awardTicketsToUser, setAwardTicketsToUser] = useState(true);
  const {
    nextRoom
  } = currentRoom || {};
  const roomCode = currentRoom?.code ?? '';
  const hasEventTickets = currentRoom?.events?.tickets;
  const isTeamRoom = currentRoom?.teams;
  const {
    data: userData
  } = useGetUserQuery();
  const {
    data: scoreboardData,
    isLoading: scoreBoardLoading
  } = useGetScoreboardDataQuery({
    roomCode,
    limit: 2
  });
  // if experiment passed, we will create a new endpoint
  const userName = userData?.data?.user.username;
  const currentUser = isTeamRoom ? undefined : scoreboardData?.data?.find(user => user.username === userName);
  const userScore = currentUser?.score;
  const userTasks = currentUser?.tasks ?? [];
  const userTotalTasks = Object.keys(userTasks).length;
  const isUserSubscribed = userData?.data?.user?.isPremium;
  const RedeemTickets = React.lazy(() => import('../../../completion-modal/components/redeem-tickets').then(module => ({
    default: module.RedeemTickets
  })));
  return <StyledContentWrapper data-sentry-element="StyledContentWrapper" data-sentry-component="RecordsStep" data-sentry-source-file="records-step.tsx">
      <StyledAvatar data-sentry-element="StyledAvatar" data-sentry-source-file="records-step.tsx">
        <Avatar hasBorder avatarSrc={currentRoom?.imageURL ?? ''} size="20rem" mobileSize="15rem" borderWidth="6px" borderColor={theme.colors.primary.main} data-sentry-element="Avatar" data-sentry-source-file="records-step.tsx" />
        <StyledCircleCheck data-sentry-element="StyledCircleCheck" data-sentry-source-file="records-step.tsx">
          <FontAwesomeIcon icon={faCheck} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="records-step.tsx" />
        </StyledCircleCheck>
      </StyledAvatar>
      <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="records-step.tsx">Congratulations on completing {currentRoom?.title}!!! 🎉</StyledTitle>
      {isLoading || scoreBoardLoading ? <StyledFlex justifyContent="center">
          <StyledLoading width="16rem" height="9.4rem" />
          <StyledLoading width="16rem" height="9.4rem" />
          <StyledLoading width="16rem" height="9.4rem" />
          <StyledLoading width="16rem" height="9.4rem" />
          <StyledLoading width="16rem" height="9.4rem" />
        </StyledFlex> : <>
          <StyledFlex justifyContent="center">
            {isTeamRoom ? null : <>
                <RecordItem title="Points earned" icon={faCrosshairs} content={userScore} recordType="points" />
                <RecordItem title="Completed tasks" icon={faListCheck} content={userTotalTasks} recordType="tasks" />
              </>}

            <RecordItem title="Room type" icon={currentRoom?.type === 'walkthrough' ? faRoute : faFlag} content={currentRoom?.type} recordType="room-type" />
            <RecordItem title="Difficulty" content={<Difficulty difficulty={currentRoom?.difficulty ?? 'easy'} isDarkVersion hasIcon fontSize="2.4rem" />} recordType="streak" />
            <RecordItem title="Streak" icon={faFire} content={userData?.data?.user?.streak?.streak} recordType="streak" />
          </StyledFlex>

          <FireshipCampaignBar overrideRules isCongratulationModal />

          {isFeedbackSent && <StyledSentFeedbackMsg>
              <FontAwesomeIcon icon={faCheck} /> <p>Sent! Thank you for your feedback!</p>
            </StyledSentFeedbackMsg>}
        </>}
      <Suspense fallback={<StyledLoading height="20rem" />} data-sentry-element="Suspense" data-sentry-source-file="records-step.tsx">
        {hasEventTickets && awardTicketsToUser && <StyledRedeemTicketsWrapper>
            <RedeemTickets username={userName ?? ''} isUserSubscribed={isUserSubscribed || false} isPathway={Boolean(nextRoom)} roomCode={currentRoom?.code ?? ''} setAwardTicketsToUser={setAwardTicketsToUser} />
          </StyledRedeemTicketsWrapper>}
      </Suspense>
    </StyledContentWrapper>;
};